module.exports = __webpack_public_path__ + "img/waltz.a621427b.jpg";